//@flow
import Badge from './src/badge'
export {
  Badge
}
export default Badge;